import * as React from 'react';

const useResizeWidth = <T extends HTMLElement>(containerRef: React.RefObject<T>): number => {
  const [width, setWidth] = React.useState(0);

  const updateWidth = React.useCallback(() => {
    if (containerRef.current) {
      const updatedWidth = containerRef.current.getBoundingClientRect().width;
      setWidth(updatedWidth);
    }
  }, [containerRef]);

  React.useEffect(() => {
    window.requestAnimationFrame(() => {
      if (containerRef.current) {
        updateWidth();
      }
    });
  }, [containerRef, updateWidth]);

  React.useEffect(() => {
    if (containerRef.current) {
      window.addEventListener('resize', updateWidth);
      return () => window.removeEventListener('resize', updateWidth);
    }
  }, [containerRef, updateWidth]);

  return width;
};

export default useResizeWidth;
